import React from 'react';
import { Award, CheckCircle, Linkedin } from 'lucide-react';

const Certification = () => {
  return (
    <section id="certification" className="py-32 bg-gradient-to-b from-gray-950 via-black to-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <span className="text-teal-400 text-sm uppercase tracking-widest font-semibold mb-4 block">
              Certificación Profesional
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Destácate con la Certificación Urpe en LinkedIn
            </h2>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed">
              Al completar tu programa, obtienes una <span className="text-white font-semibold">Certificación Oficial Urpe</span> para tu perfil de LinkedIn, portafolio y currículo. Es evidencia verificable de dominio aplicado.
            </p>

            {/* Benefits */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-300">Certificado digital verificable en blockchain</p>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-300">Reconocido por empresas y fondos de inversión</p>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-300">Insignia oficial para perfil de LinkedIn</p>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-300">Acceso de por vida a actualizaciones del programa</p>
              </div>
            </div>

            <a
              href="#curriculum"
              className="inline-flex items-center px-8 py-4 bg-white/5 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-full hover:bg-white/10 hover:border-white/30 transition-all duration-300"
            >
              Ver Programas Disponibles
            </a>
          </div>

          {/* Right: Certificate Visual */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-teal-950/30 to-gray-950/30 rounded-2xl p-8 border border-teal-500/20 backdrop-blur-sm">
              {/* Glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-teal-500/20 to-teal-600/20 rounded-2xl blur-xl" />
              
              <div className="relative bg-white rounded-xl p-8 shadow-2xl">
                {/* Certificate Header */}
                <div className="text-center mb-6 border-b border-gray-200 pb-6">
                  <img
                    src="https://customer-assets.emergentagent.com/job_knowledge-hub-196/artifacts/464mphrk_Recurso%2026LOGO%20def.png"
                    alt="Urpe School Logo"
                    className="h-12 mx-auto mb-4"
                  />
                  <h3 className="text-2xl font-bold text-gray-900">Certificado de Cumplimiento</h3>
                </div>

                {/* Certificate Body */}
                <div className="text-center space-y-4">
                  <p className="text-sm text-gray-600">Este certificado se otorga a</p>
                  <h4 className="text-3xl font-bold text-teal-600">Tu Nombre</h4>
                  <p className="text-sm text-gray-600">Por completar exitosamente</p>
                  <p className="text-lg font-semibold text-gray-900">Urpe Liberty MBA</p>
                  <div className="pt-6 flex justify-center space-x-4">
                    <Award className="text-teal-500" size={32} />
                  </div>
                </div>

                {/* Certificate Footer */}
                <div className="mt-8 pt-6 border-t border-gray-200 flex justify-between items-center">
                  <div className="text-xs text-gray-500">
                    <p>ID: URPE-2025-XXXX</p>
                    <p>Fecha: 2025</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Linkedin size={16} className="text-blue-600" />
                    <span className="text-xs text-gray-500">Verificable</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certification;
